import { render, staticRenderFns } from "./modalSendEmailReciboComponent.vue?vue&type=template&id=c52bb454&scoped=true"
import script from "./modalSendEmailReciboComponent.vue?vue&type=script&lang=js"
export * from "./modalSendEmailReciboComponent.vue?vue&type=script&lang=js"
import style0 from "./modalSendEmailReciboComponent.vue?vue&type=style&index=0&id=c52bb454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52bb454",
  null
  
)

export default component.exports